import { createContext, useState } from "react";
import "../../src/styles/global.css";

export const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
  const [isStrategyOpen, setIsStrategyOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const openStrategy = () => setIsStrategyOpen(true);
  const closeStrategy = () => setIsStrategyOpen(false);

  const showToast = (message) => {
    setToastMessage(message);
    setTimeout(() => setToastMessage(""), 3000);
  };

  return (
    <ModalContext.Provider
      value={{
        isStrategyOpen,
        openStrategy,
        closeStrategy,
        showToast,
      }}
    >
      {children}

      {/* Toast */}
      {toastMessage && (
        <div className="toast">
          {toastMessage}
        </div>
      )}
    </ModalContext.Provider>
  );
};
